module.exports = __webpack_public_path__ + "img/Valencia-logo.05096cb0.png";